import $ from 'jquery'
import MicroModal from 'micromodal'
import { detect } from 'detect-browser'

const browser = detect()
const browser_version = browser.version.split('.')
const browser_html_class = browser.name + '-' + browser_version[0]

$('#google-map_trigger_js, .google-map_trigger_js').on('click', function (event) {
	event.preventDefault()

	MicroModal.show('modal-google-map_js', {
		onShow: () => {
			const map_element = document.getElementById('property_map_js')
			const coordinates = map_element.dataset.coordinates.split(',')
			const lat = parseFloat(coordinates[0])
			const lng = parseFloat(coordinates[1])

			const map_coordinates = new window.google.maps.LatLng(lat, lng)

			const map = new window.google.maps.Map(map_element, {
				center: map_coordinates,
				zoom: 12,
				mapTypeControl: true,
				mapTypeControlOptions: {
					style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
					position: window.google.maps.ControlPosition.TOP_CENTER,
				},
				zoomControl: true,
				zoomControlOptions: {
					position: window.google.maps.ControlPosition.RIGHT_CENTER,
				},
				scaleControl: true,
				streetViewControl: true,
				streetViewControlOptions: {
					position: window.google.maps.ControlPosition.LEFT_TOP,
				},
				fullscreenControl: true,
			})

			const icon = {
				url: window.theme_path.path + '/assets/images/map-marker.svg',
			}

			browser_html_class === 'ie-11' ? (icon.scaledSize = new window.google.maps.Size(100, 100)) : ''

			new window.google.maps.Marker({
				position: map_coordinates,
				map,
				animation: window.google.maps.Animation.DROP,
				icon: icon,
			})
		},
		onClose: (modal, element, event) => {
			if (event) {
				event.preventDefault()
				event.stopPropagation()
			}
		},
		disableScroll: true,
	})
})
